<div class="card container">
  <div class="row justify-content-start" style="padding-top: 1rem">
    <div class="col-auto align-self-end">
      <h3 class="card-title" style="margin-bottom: 0">Compañias</h3>
    </div>
    <div class="col-auto align-self-start">
      <p-button
        label="Nuevo"
        severity="primary"
        icon="pi pi-plus"
        size="small"
        (onClick)="openDialog(true, null)"
      />
    </div>
  </div>
  <div style="padding-top: 50px">
    <p-table
      [value]="ltsCompany"
      [loading]="loading"
      [tableStyle]="{
        'min-width': '50rem',
        'margin-bottom': '50px',
      }"
      styleClass="p-datatable-striped p-datatable-sm"
    >
      <ng-template pTemplate="caption">
        <div class="d-flex justify-content-end">
          <p-button
            [rounded]="true"
            icon="pi pi-refresh"
            (onClick)="getListCompany()"
          />
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th id="tbname">Nombre</th>
          <th id="tbphone">Telefono</th>
          <th id="tbaddres">Direccion</th>
          <th id="tblogo">Logo</th>
          <th id="tbstatus">Estado</th>
          <th id="tbaction">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-company>
        <tr>
          <td>{{ company.com_name }}</td>
          <td>{{ company.com_phone }}</td>
          <td>{{ company.com_address }}</td>
          <td>
            <img
              width="70"
              height="70"
              alt="logo"
              src="data:image/png;base64,{{ company.com_logo }}"
            />
          </td>
          <td>
            <p-inputSwitch
              [(ngModel)]="company.estado"
              (onChange)="cambiarEstado(company)"
            />
          </td>
          <td>
            <p-button
              icon="pi pi-file-edit"
              [rounded]="true"
              severity="info"
              pTooltip="Editar"
              tooltipPosition="right"
              (onClick)="openDialog(false, company)"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  header="{{ tituloDialog }}"
  [resizable]="false"
  [modal]="true"
  [maximizable]="false"
  appendTo="body"
  [(visible)]="dialogCompany"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '40rem' }"
>
  <div class="d-flex justify-content-center">
    <div class="container offset-md-1">
      <form [formGroup]="formCompany" (submit)="saveCompany()">
        <div class="row gap-2">
          <div class="row rowPad align-items-center">
            <div class="col-12 col-sm-3">
              <label for="float-input">Nombre*:</label>
            </div>
            <div class="col-12 col-sm-8">
              <input
                type="text"
                pInputText
                class="largeInput"
                id="name"
                formControlName="com_name"
                placeholder="Nombre"
              />
              @if (
                formCompany.get("com_name")?.invalid &&
                formCompany.get("com_name")?.dirty
              ) {
                <small class="text-danger labelError">
                  El campo es requerido
                </small>
              }
            </div>
          </div>
          <div class="row rowPad align-items-center">
            <div class="col-12 col-sm-3">
              <label for="float-input">Telefono*:</label>
            </div>
            <div class="col-12 col-sm-8">
              <input
                type="text"
                pInputText
                class="largeInput"
                id="phone"
                formControlName="com_phone"
                placeholder="Telefono"
              />
              @if (
                formCompany.get("com_phone")?.invalid &&
                formCompany.get("com_phone")?.dirty
              ) {
                <small class="text-danger labelError">
                  El campo es requerido
                </small>
              }
            </div>
          </div>
          <div class="row rowPad align-items-center">
            <div class="col-12 col-sm-3">
              <label for="float-input">Dirección*:</label>
            </div>
            <div class="col-12 col-sm-8">
              <input
                type="text"
                pInputText
                class="largeInput"
                id="address"
                formControlName="com_address"
                placeholder="Dirección"
              />
              @if (
                formCompany.get("com_address")?.invalid &&
                formCompany.get("com_address")?.dirty
              ) {
                <small class="text-danger labelError">
                  El campo es requerido
                </small>
              }
            </div>
          </div>
          <div class="row rowPad align-items-center">
            <div class="col-12 col-sm-3">
              <label for="float-input">Logo*:</label>
            </div>
            <div class="col-12 col-sm-8">
              <p-fileUpload
                chooseLabel="Choose"
                chooseIcon="pi pi-upload"
                [multiple]="false"
                [showUploadButton]="false"
                [showCancelButton]="false"
                maxFileSize="1000000"
                (onSelect)="onSelectImage($event.files)"
                (onRemove)="removeFile()"
                accept=".png"
                invalidFileTypeMessageDetail="Solo puede seleccionar archivos con extension(es) {0}"
                invalidFileTypeMessageSummary="El archivo {0} no tiene una extensión válida."
                invalidFileSizeMessageSummary="El tamaño del archivo es inválido: {0}"
                invalidFileSizeMessageDetail="El tamaño máximo permitido es: {0}"
                invalidFileLimitMessageSummary="Se ha excedido el número máximo de archivos a cargar."
                invalidFileLimitMessageDetail="Máximos archivos permitidos: {0}"
              >
                <ng-template pTemplate="content">
                  @if (uploadedFiles.length) {
                    <ul>
                      @for (file of uploadedFiles; track file) {
                        <li>{{ file.name }} - {{ file.size }} bytes</li>
                      }
                    </ul>
                  }
                </ng-template>
              </p-fileUpload>
            </div>
          </div>

          <div class="d-flex justify-content-end p-2">
            <p-button
              class="p-1"
              label="Cancel"
              severity="primary"
              (onClick)="cancel()"
            />
            <p-button
              class="p-1"
              label="Save"
              type="submit"
              [disabled]="formCompany.invalid"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>
